import { createAction } from "@reduxjs/toolkit";

export const resetLoginStatus = createAction("user/login/reset");
export const resetSignUpStatus = createAction("user/signup/reset");
export const resetgetUserStatus = createAction("user/profile/reset");
